<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title :id="iconName" lang="ja">{{ iconName }}</title>
    <g :fill="iconColor">
      <slot />
    </g>
  </svg>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    iconName: { type: String, default: "" },
    width: { type: [Number, String], default: 32 },
    height: { type: [Number, String], default: 32 },
    iconColor: { type: String, default: "currentColor" },
    viewBox: { type: String, default: "0 0 32 32" }
  }
})
export default class IconBase extends Vue {
  iconName!: string;
  width!: string;
  height!: string;
  iconColor!: string;
  viewBox!: string;
}
</script>

<style lang="scss" scoped>
g {
  transition: all $transition-sec--fast ease-in;
}
</style>
